export function Currency({ price, discount = 0, count = 1 }, currency = 'TRY') {
  const formatter = new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency,
  })
  return formatter.format((((100 - discount) * price) / 100) * count)
}
